import * as rsa from 'rsa'
import { NoInputVizPortalClientMethod } from '../VizPortalClientMethod';

export interface GeneratePublicKeyResult {
  key: rsa.IRSAPublicKey;
  keyId: string;
}

export const GeneratePublicKeyMethod = new NoInputVizPortalClientMethod<GeneratePublicKeyResult>('generatePublicKey');
